/**
 * useProductImage – 3-Tier Bild-Hierarchie Hook
 *
 * Priorität:
 *   1. master_image_path   → Emergent Storage (Superadmin-Bild)
 *   2. image_url           → OFF-URL (extern, schnell)
 *   3. customer_image_path → Emergent Storage (Kunden-Foto)
 *   4. Fallback            → null (Platzhalter anzeigen)
 */

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : '/api';

/**
 * Gibt die optimale Bild-URL für ein Produkt zurück.
 *
 * @param {object} product - Produktdaten (master_image_path, image_url, customer_image_path)
 * @param {string} token   - JWT-Token für Storage-Bilder
 * @returns {string|null}  - Bild-URL oder null
 */
export const resolveProductImage = (product, token) => {
  if (!product) return null;

  // Tier 1: Master-Bild aus Emergent Storage (Superadmin gesetzt)
  if (product.master_image_path) {
    return `${API}/images/${product.master_image_path}?auth=${token}`;
  }

  // Tier 2: Externe OFF-URL (direkt, kein Auth nötig)
  if (product.image_url && !product.image_url.startsWith('data:')) {
    return product.image_url;
  }

  // Tier 3: Kunden-Foto aus Emergent Storage
  if (product.customer_image_path) {
    return `${API}/images/${product.customer_image_path}?auth=${token}`;
  }

  // Legacy: base64 (rückwärtskompatibel)
  if (product.image_url && product.image_url.startsWith('data:')) {
    return product.image_url;
  }

  // Lokales Foto (aus Scan-Dialog)
  if (product.photo && product.photo.startsWith('data:')) {
    return product.photo;
  }

  return null;
};

/**
 * Gibt die Storage-URL für einen bekannten Pfad zurück.
 * Nützlich wenn der Pfad direkt bekannt ist.
 */
export const storageImageUrl = (storagePath, token) => {
  if (!storagePath) return null;
  return `${API}/images/${storagePath}?auth=${token}`;
};
